import React from 'react';
import styled from 'styled-components';

const Container = styled.svg``;

const CarCheckmarkIcon = (props: any) => (
  <Container width="57" height="57" viewBox="0 0 57 57" {...props}>
    <title>Car Checkmark</title>
    <g>
      <svg
        width="57"
        height="57"
        viewBox="0 0 57 57"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.5526 39.9636H6.2312C5.12663 39.9636 4.2312 39.0681 4.2312 37.9636V27.3683C4.2312 26.8379 4.44191 26.3292 4.81699 25.9541L7.99275 22.7784C8.26087 22.5102 8.44725 22.1714 8.53015 21.8014L10.5324 12.8655C10.737 11.952 11.5479 11.3027 12.484 11.3027H22.5526"
          stroke="#00619E"
          strokeWidth="2"
        />
        <path
          d="M22.355 22.5881H4.55249C4.00021 22.5881 3.55249 22.1404 3.55249 21.5881V19.266C3.55249 18.7138 4.00005 18.2661 4.55223 18.266L9.72643 18.2646"
          stroke="#00619E"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <circle
          cx="10.6372"
          cy="31.715"
          r="2.8"
          stroke="#00619E"
          strokeWidth="2"
        />
        <path
          d="M7.94849 42.833V44.3667C7.94849 44.9189 8.3962 45.3667 8.94849 45.3667H14.4202C14.9724 45.3667 15.4202 44.9189 15.4202 44.3667V42.833"
          stroke="#00619E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M27.5039 38.9636C28.0562 38.9636 28.5039 39.4113 28.5039 39.9636C28.5039 40.5158 28.0562 40.9636 27.5039 40.9636V38.9636ZM41.8738 27.4171C41.8738 27.9694 41.4261 28.4171 40.8738 28.4171C40.3215 28.4171 39.8738 27.9694 39.8738 27.4171H41.8738ZM37.1122 22.7784L37.8193 22.0713L37.1122 22.7784ZM40.288 25.9541L39.5809 26.6612L40.288 25.9541ZM39.5809 26.6612L36.4051 23.4855L37.8193 22.0713L40.9951 25.247L39.5809 26.6612ZM35.599 22.0201L33.5968 13.0841L35.5484 12.6468L37.5506 21.5828L35.599 22.0201ZM32.621 12.3027H22.5524V10.3027H32.621V12.3027ZM22.5524 38.9636H27.5039V40.9636H22.5524V38.9636ZM39.8738 27.4171V27.3683H41.8738V27.4171H39.8738ZM33.5968 13.0841C33.4945 12.6274 33.0891 12.3027 32.621 12.3027V10.3027C34.0251 10.3027 35.2414 11.2767 35.5484 12.6468L33.5968 13.0841ZM36.4051 23.4855C36.0029 23.0833 35.7234 22.5751 35.599 22.0201L37.5506 21.5828C37.5921 21.7678 37.6853 21.9372 37.8193 22.0713L36.4051 23.4855ZM40.9951 25.247C41.5577 25.8096 41.8738 26.5727 41.8738 27.3683H39.8738C39.8738 27.1031 39.7684 26.8488 39.5809 26.6612L40.9951 25.247Z"
          fill="#00619E"
        />
        <path
          d="M35.3785 18.2646L40.5527 18.266C41.1049 18.2661 41.5525 18.7138 41.5525 19.266V21.5881C41.5525 22.1404 41.1048 22.5881 40.5525 22.5881H22.75H21.7084"
          stroke="#00619E"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M35.7458 29.0131C35.4383 28.909 35.1088 28.8525 34.7662 28.8525C33.08 28.8525 31.7131 30.2195 31.7131 31.9056C31.7131 32.2477 31.7693 32.5767 31.8731 32.8837"
          stroke="#00619E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M28.7348 42.833V44.7418C28.7348 45.0869 29.0145 45.3667 29.3596 45.3667V45.3667"
          stroke="#00619E"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M19.1138 31.6768C18.5615 31.6768 18.1138 32.1245 18.1138 32.6768C18.1138 33.229 18.5615 33.6768 19.1138 33.6768V31.6768ZM25.9914 33.6768C26.5437 33.6768 26.9914 33.229 26.9914 32.6768C26.9914 32.1245 26.5437 31.6768 25.9914 31.6768V33.6768ZM19.1138 33.6768H25.9914V31.6768H19.1138V33.6768Z"
          fill="#00619E"
        />
        <path
          d="M42.2518 31.4966C42.8041 31.4966 43.2518 31.0489 43.2518 30.4966C43.2518 29.9443 42.8041 29.4966 42.2518 29.4966V31.4966ZM49.4459 33.2299L50.13 32.5006C49.9333 32.3161 49.6705 32.2189 49.4011 32.231C49.1318 32.243 48.8787 32.3633 48.6993 32.5646L49.4459 33.2299ZM50.0641 33.7064L49.361 34.4176V34.4176L50.0641 33.7064ZM39.0391 44.9081L38.3097 45.5922C38.5017 45.7969 38.771 45.9116 39.0518 45.908C39.3325 45.9044 39.5988 45.783 39.7856 45.5734L39.0391 44.9081ZM36.804 41.0633C36.4262 40.6604 35.7934 40.6402 35.3905 41.018C34.9877 41.3958 34.9674 42.0286 35.3452 42.4315L36.804 41.0633ZM52.3637 41.6085C52.3637 47.1932 47.8365 51.7204 42.2518 51.7204V53.7204C48.941 53.7204 54.3637 48.2977 54.3637 41.6085H52.3637ZM42.2518 51.7204C36.6672 51.7204 32.1399 47.1932 32.1399 41.6085H30.1399C30.1399 48.2977 35.5626 53.7204 42.2518 53.7204V51.7204ZM32.1399 41.6085C32.1399 36.0238 36.6672 31.4966 42.2518 31.4966V29.4966C35.5626 29.4966 30.1399 34.9193 30.1399 41.6085H32.1399ZM48.7618 33.9593C48.8043 33.9992 48.8491 34.0348 48.8691 34.0507C48.8969 34.0727 48.9279 34.0965 48.958 34.1194C49.0183 34.1651 49.0913 34.2195 49.1578 34.2691C49.2271 34.3208 49.2902 34.3679 49.3397 34.4059C49.3645 34.425 49.3816 34.4384 49.3921 34.4468C49.4117 34.4627 49.3916 34.4478 49.361 34.4176L50.7672 32.9953C50.7192 32.9479 50.6689 32.9072 50.6488 32.891C50.6196 32.8673 50.5874 32.8423 50.5566 32.8187C50.4949 32.7714 50.4212 32.7163 50.3536 32.6659C50.2832 32.6134 50.2192 32.5658 50.1677 32.5267C50.142 32.5072 50.1234 32.4928 50.1112 32.4831C50.0911 32.4672 50.1054 32.4775 50.13 32.5006L48.7618 33.9593ZM49.361 34.4176C51.2161 36.2517 52.3637 38.7952 52.3637 41.6085H54.3637C54.3637 38.2392 52.9867 35.1898 50.7672 32.9953L49.361 34.4176ZM48.6993 32.5646L38.2925 44.2428L39.7856 45.5734L50.1925 33.8953L48.6993 32.5646ZM39.7684 44.224L36.804 41.0633L35.3452 42.4315L38.3097 45.5922L39.7684 44.224Z"
          fill="#00AED9"
        />
      </svg>
    </g>
  </Container>
);

export default CarCheckmarkIcon;
